import { IElement } from "../IProcessData";
import { migrate as apiTriggerSchemaMigration } from "./ApiTriggerSchemaMigration"
import { migrate as fileWatchMigrate } from "./FileWatchTriggerConfigMigration";
import { migrate as remoteCallTimeoutMigrate } from "./RemoteCallTimeoutMigration";
import { migrate as scheduleTriggerRepeatDelayMigrate } from "./ScheduleTriggerRepeatDelayConfigMigration";
import { migrate as remoteExecutionModeMigration } from "./RemoteExecutionModeMigration";
import { migrate as httpTriggerPolicyAuthMigration } from "./HttpTriggerPolicyAuthMigration";

const migrations = [
    fileWatchMigrate,
    remoteCallTimeoutMigrate,
    scheduleTriggerRepeatDelayMigrate,
    apiTriggerSchemaMigration,
    remoteExecutionModeMigration,
    httpTriggerPolicyAuthMigration
];

export function migrateElementData(element: IElement) {
    let migratedElement = element;
    for (const migration of migrations) {
        const migrationParameters: IMigrationParameters = { element: migratedElement };
        migratedElement = migration.call(this, migrationParameters);
    }

    return migratedElement;
}

export interface IMigrationParameters {
    element: IElement;
}
